import React, { Component } from 'react';
import ProjectCard from './ProjectCard/ProjectCard';
import DetailsPane from './DetailsPane'
import moment from 'moment'
import axios from 'axios';
import './Projects.css';
import { APIURL } from '../../config'
import { withStyles } from '@mui/styles';
import Tooltip from "@mui/material/Tooltip";
import { TextField, InputAdornment, IconButton, Button, Autocomplete, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { Redirect, withRouter } from 'react-router-dom';

const styles = {
    projList1: {
        height: 'calc(100vh - 249px)',
        width: "100%",
        overflowY: 'auto',
        scrollbarGutter: 'stable',
    },
    projList2: {
        height: 'calc(100vh - 545px)',
        width: "100%",
        overflowY: 'auto',
        scrollbarGutter: 'stable',
    }
};

class Projects extends Component {
    state = {
        showProjectDetails: false,
        projects: [],
        searchTerm: '',
        projectSearchResults: [],
        dropDowns: null,
        inputValue: '',
        isLoading: true,
        current_project: null,
        project_type: 'new', // new, old, initial
        ongoing_project: [],
        showMap: false,
        isSupport: this.props.user?.comp_settings.find(setting => setting.feature_id === 101 && setting.feature_value === 'primaryBusinessType') ? true : false,
        tabName: this.props.companySettings.length > 1 && this.props.companySettings.filter(setting => [101, 102].includes(setting.feature_id)).length > 0 ? 'Plan' : this.props.companySettings.length > 1 && this.props.companySettings.filter(setting => [104].includes(setting.feature_id)).length > 0 ? 'Cases' : 'Projects',
        loadingAllProjects: true,
        redirectToNew: false,
        sortByValue: 'title',
    }

    loadProjects = async () => {
        this.props.checkTokenExpiry()
        axios.defaults.headers = {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            "Access-Control-Allow-Headers": 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
            "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
            "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
            Authorization: 'Bearer ' + window.localStorage.getItem('Fw4_access_Token')
        }

        const baseParams = {
            company_id: this.props.comp_id,
            ...(this.props.selectedProgramId ? { program_id: this.props.selectedProgramId } : {})
        };

        // queryType: 0 --> Fetch only 25 Projects
        // queryType: 1 --> Fetch rest of the Projects
        let pData = (this.props.user.permissions.AdminLevelProjects) ?
            await axios.get(APIURL + "/project/v1", { params: { ...baseParams, queryType: 0 } }) :
            await axios.get(APIURL + "/project/v1", { params: { ...baseParams, emp_id: this.props.user.emp_id, type: (this.props.user.permissions.ManagerLevelProjects) ? 'Manager' : 'Fieldworker' } })
        let projList = pData.data
        let ongoing_project = projList.filter((proj) => proj.pro_starts_on && proj.pro_ends_on && !moment(proj.pro_ends_on).isBefore(moment()))

        const navProps = this.props.location && this.props.location.projectsProps;
        const preselectId = navProps && navProps.pro_id;
        const preselect = preselectId && projList.find(p => p.pro_id === preselectId);
        this.setState({
            projects: projList,
            projectSearchResults: ongoing_project,
            ongoing_project,
            isLoading: false,
            current_project: preselect ? preselect.pro_id : (preselectId ? null : (ongoing_project.length > 0 ? ongoing_project[0].pro_id : null)),
            project_type: preselect ? this.getProjectType(preselect) : 'new',
            openTab: navProps && navProps.tab != null ? navProps.tab : undefined,
        }, () => this.sortBy(this.state.sortByValue));

        if (this.props.user.permissions.AdminLevelProjects) {
            let pData = await axios.get(APIURL + "/project/v1", { params: { ...baseParams, queryType: 1 } })
            let projList = pData.data
            let ongoing_project = projList.filter((proj) => proj.pro_starts_on && proj.pro_ends_on && !moment(proj.pro_ends_on).isBefore(moment()))
            const allProjects = [...this.state.projects, ...projList];
            const navProps2 = this.props.location && this.props.location.projectsProps;
            const preselectId2 = navProps2 && navProps2.pro_id;
            const stillWrong = preselectId2 && this.state.current_project !== preselectId2;
            const latePreselect = stillWrong && allProjects.find(p => p.pro_id === preselectId2);
            this.setState({
                projects: allProjects,
                projectSearchResults: [...this.state.projectSearchResults, ...ongoing_project],
                ongoing_project: [...this.state.ongoing_project, ...ongoing_project],
                loadingAllProjects: false,
                ...(latePreselect ? { current_project: latePreselect.pro_id, project_type: this.getProjectType(latePreselect), openTab: navProps2.tab != null ? navProps2.tab : undefined } : {}),
            }, () => this.sortBy(this.state.sortByValue));
        } else {
            this.setState({
                loadingAllProjects: false,
            }, () => this.sortBy(this.state.sortByValue));
        }
    }

    async componentDidMount() {
        await this.loadProjects();
    }

    componentDidUpdate(prevProps) {
        const prev = prevProps.location && prevProps.location.projectsProps;
        const curr = this.props.location && this.props.location.projectsProps;
        if (curr && curr !== prev && curr.pro_id) {
            const proj = this.state.projects.find(p => p.pro_id === curr.pro_id);
            this.setState({
                current_project: curr.pro_id,
                project_type: this.getProjectType(proj),
                openTab: curr.tab != null ? curr.tab : undefined,
            });
        }

        if (prevProps.selectedProgramId !== this.props.selectedProgramId) {
            this.setState({ isLoading: true }, async () => {
                await this.loadProjects();
            });
        }
    }

    getProjectType = (proj) => {
        if (!proj) return 'new';
        const start = proj.pro_starts_on;
        const end = (proj.pro_ends_on || '').replace(/Z/g, '');
        if (moment(start).isSameOrBefore('1900-01-01') && moment(end).isSame('1900-01-02', 'day')) return 'renewal';
        if (!start || !proj.pro_ends_on || moment(start).isSameOrBefore('1900-01-01')) return 'initial';
        if (!moment(proj.pro_ends_on).isBefore(moment())) return 'new';
        return 'old';
    }

    showProjectDetails = (key) => {
        this.setState({
            current_project: key,
            openTab: undefined,
        })
    }

    onBackClicked = () => {
        this.setState({
            showProjectDetails: false,
            current_project: null
        })
    }

    showProjectList = () => {
        if (this.state.ongoing_project) {
            return this.state.projectSearchResults.map(
                projects => <ProjectCard
                    {...this.props}
                    key={projects.pro_id}
                    id={projects.pro_id}
                    title={projects.pro_title}
                    start={projects.pro_starts_on || ''}
                    end={projects.pro_ends_on}
                    customerName={projects.customer_details[0].cus_name}
                    location={projects.locations ? projects.locations[0] : {}}
                    onClick={this.showProjectDetails}
                    onBack={this.onBackClicked}
                    selected={this.state.current_project === projects.pro_id ? 'active' : 'inactive'}
                />
            )
        } else {
            return <div>Loading....</div>
        }
    }

    generateMapsData = () => {
        let mapsData = this.state.projects.length !== 0 ? this.state.projects.map((pushPinData) => {
            if (!!pushPinData.locations) {
                return {
                    "location": [+pushPinData.locations[0].loc_lat || 0, +pushPinData.locations[0].loc_lon || 0],
                    "addHandler": "mouseover",
                    "infoboxOption": { title: pushPinData.customer_details[0].cus_name, description: pushPinData.locations[0].loc_addr_line1 + ',' + pushPinData.locations[0].loc_addr_line2 + "," + pushPinData.locations[0].loc_city + "," + pushPinData.locations[0].loc_state + "," + pushPinData.locations[0].loc_zip },
                    "pushPinOption": { color: 'red', title: pushPinData.pro_title }
                }
            } else { return null }

        }).filter((mp) => !!mp) : []
        return mapsData
    }

    searchProjHandler = (e) => {
        console.log(e.target.value);
        var searchQuery = e.target.value
        e.preventDefault()
        var searchTerm = new RegExp(searchQuery, 'i')
        console.log(searchTerm);
        let projectSearchResults = this.state.ongoing_project.map((proj) => {
            if (searchTerm.exec(proj.pro_title) || searchTerm.exec(proj.customer_details[0].cus_name)) {
                return proj
            }
            else {
                return null
            }
        }).filter((proj) => !!proj)

        this.setState({ projectSearchResults: projectSearchResults,  searchTerm: searchQuery },
            () => this.sortBy(this.state.sortByValue)
        );
    }

    searchProjResults = (e) => {
        e.preventDefault()
        var searchTerm = new RegExp(this.state.searchTerm, 'i')
        console.log(searchTerm)
        let projectSearchResults = this.state.ongoing_project.map((proj) => {
            if (searchTerm.exec(proj.pro_title) || searchTerm.exec(proj.customer_details[0].cus_name)) {
                return proj
            }
            else {
                return null
            }
        }).filter((proj) => !!proj)

        this.setState({ projectSearchResults: projectSearchResults },
            () => this.sortBy(this.state.sortByValue)
        )
    }

    filterProjects = (screen) => {
        if ((screen === 'old' && this.state.project_type === 'old') || (screen === 'new' && this.state.project_type === 'new') || (screen === 'initial' && this.state.project_type === 'initial') || (screen === 'renewal' && this.state.project_type === 'renewal')) {
            return
        } else {
            let newProjects = [];
            let oldProjects = [];
            let initialProjects = [];
            let renewalProjects = [];
            let pData = []

            this.state.projects.forEach((proj) => {

                console.log(proj.pro_title)

                console.log(proj.pro_ends_on)
                console.log(moment(proj.pro_ends_on.replace(/Z/g, "")).format('LLL'))

                if (moment(proj.pro_starts_on).isSameOrBefore("1900-01-01") && moment(proj.pro_ends_on.replace(/Z/g, "")).isSame("1900-01-02", 'day')) {
                    renewalProjects.push(proj)
                } else if (!proj.pro_starts_on || !proj.pro_ends_on || moment(proj.pro_starts_on).isSameOrBefore("1900-01-01")) {
                    initialProjects.push(proj)
                } else if (!moment(proj.pro_ends_on).isBefore(moment())) {
                    newProjects.push(proj)
                } else if (moment(proj.pro_ends_on).isBefore(moment())) {
                    oldProjects.push(proj)
                }
            })

            if (screen === 'new') {
                pData = newProjects
            } else if (screen === 'old') {
                pData = oldProjects
            } else if (screen === 'initial') {
                pData = initialProjects
            } else if (screen === 'renewal') {
                pData = renewalProjects
            }

            this.setState({ searchTerm: '', ongoing_project: pData, projectSearchResults: pData, project_type: screen, current_project: pData.length > 0 ? pData[0].pro_id : null },
                () => this.sortBy(this.state.sortByValue)
            )
        }
    }

    sortBy = (param) => {
        const { projects, projectSearchResults } = this.state;
        const sortedProjects = [...projects];
        const sortedSearchResults = [...projectSearchResults];
        if (param === 'title') {
            sortedProjects.sort((a, b) => ('' + a.pro_title).localeCompare(b.pro_title));
            sortedSearchResults.sort((a, b) => ('' + a.pro_title).localeCompare(b.pro_title));
        } else {
            sortedProjects.sort((a, b) => moment(b.pro_starts_on) - moment(a.pro_starts_on));
            sortedSearchResults.sort((a, b) => moment(b.pro_starts_on) - moment(a.pro_starts_on));
        }
        this.setState({ projects: sortedProjects, projectSearchResults: sortedSearchResults });
    }

    handleSortByChange = (event) => {
        const value = event.target.value;
        this.setState({ sortByValue: value });
        this.sortBy(value);
    };

    toggleMap = () => {
        this.setState(prev => ({ showMap: !this.state.showMap }));
    };

    render() {
        const { classes } = this.props;
        const statusOptions = [
            { value: 'new',     label: `Ongoing ${this.state.tabName}` },
            { value: 'old',     label: `Completed ${this.state.tabName}` },
            ...(this.state.isSupport ? [{ value: 'initial', label: `Initial ${this.state.tabName}` }] : []),
            { value: 'renewal', label: `Late Renewal ${this.state.tabName}` }
        ];

        let dashBoard = null;
        if (!this.state.isLoading) {
            dashBoard = (
                <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
                    {/* top nav */}
                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', padding: '10px', gap: '20px' }}>
                        <Autocomplete
                            freeSolo
                            clearOnBlur={false}
                            inputValue={this.state.inputValue}
                            onInputChange={(e, newInput) => {
                                // Only update if newInput is not null/undefined
                                if (newInput !== null && newInput !== undefined) {
                                    this.setState({ inputValue: newInput });
                                }
                            }}
                            disableClearable
                            options={this.state.projectSearchResults}
                            getOptionLabel={p => p.pro_title || ''}
                            onChange={(e, val) => {
                                // Only update when a valid option is selected
                                if (val && typeof val === 'object' && val.pro_id) {
                                    this.setState({
                                        current_project: val.pro_id,
                                        inputValue: val.pro_title
                                    });
                                }
                                // If val is null/undefined or just a string, don't update
                            }}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    label="Project"
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            )}
                            style={{ flex: '0 0 300px' }}
                            renderOption={(props, item) => (
                                <li {...props} key={item.key}>
                                    {item.pro_title}
                                </li>
                            )}
                        />
                        <Autocomplete
                            options={statusOptions}
                            getOptionLabel={opt => opt.label}
                            value={statusOptions.find(o => o.value === this.state.project_type) || null}
                            onChange={(e, val) => val && this.filterProjects(val.value)}
                            renderInput={params =>
                                <TextField {...params} label="Status" variant="outlined" size="small" />}
                            style={{ flex: '0 0 250px' }}
                        />
                        {/* Sort By select for projects */}
                        <FormControl variant="outlined" size="small" style={{ flex: '0 0 200px' }}>
                            <InputLabel>Sort By</InputLabel>
                            <Select
                                value={this.state.sortByValue}
                                onChange={this.handleSortByChange}
                                label="Sort By"
                            >
                                <MenuItem value="title">Title</MenuItem>
                                <MenuItem value="date">Date</MenuItem>
                            </Select>
                        </FormControl>

                        {/* Current Project Title Display */}
                        {this.state.current_project && (
                            <div style={{ 
                                flex: '1', 
                                display: 'flex', 
                                alignItems: 'center',
                                paddingLeft: '20px',
                                borderLeft: '2px solid #257bcd'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>
                                        Current Project
                                    </span>
                                    <span style={{ fontSize: '18px', fontWeight: '600', color: '#333' }}>
                                        {this.state.projects.find(p => p.pro_id === this.state.current_project)?.pro_title || 'No Project Selected'}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                    {/* scrollable content area */}
                    <div style={{ display: 'flex', height: 'calc(100vh - 150px)' }}>
                        {this.state.current_project ? (
                            <DetailsPane
                                status={this.state.project_type === 'new' ? 'Ongoing'
                                     : this.state.project_type === 'old' ? 'Older' : 'Initial'}
                                comp_id={this.props.comp_id}
                                user={this.props.user}
                                history={this.props.history}
                                openTab={this.state.openTab}
                                project_details={this.state.projects.find(p => p.pro_id === this.state.current_project)}
                                updateProject={async () => {
                                    const pData = (this.props.user.permissions.AdminLevelProjects)
                                        ? await axios.get(APIURL + "/project/v1", { params: { company_id: this.props.comp_id } })
                                        : await axios.get(APIURL + "/project/v1", {
                                              params: {
                                                  company_id: this.props.comp_id,
                                                  emp_id: this.props.user.emp_id,
                                                  type: this.props.user.permissions.ManagerLevelProjects ? 'Manager' : 'Fieldworker'
                                              }
                                          });
                                    this.setState({ projects: pData.data });
                                }}
                                companySettings={this.props.companySettings}
                                checkTokenExpiry={this.props.checkTokenExpiry}
                            />
                        ) : this.state.loadingAllProjects && this.props.location?.projectsProps?.pro_id ? (
                            <div className="d-flex flex-row justify-content-center" style={{ width: '100%' }}>
                                <div style={{ color: '#3FA7D6', height: '5rem', width: '5rem', marginTop: 80 }}
                                     className="spinner-border text-info" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div style={{ padding: 20 }}>Select a project above to view details.</div>
                        )}
                    </div>
                </div>
            )
        } else {
            dashBoard = (
                <div className="d-flex flex-row justify-content-center">
                    <div style={{
                        color: '#3FA7D6',
                        height: '10rem',
                        width: '10rem',
                        marginTop: 120
                    }} className="spinner-border text-info" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            )
        }

        return (
            <div style={{ height: 'calc(100vh - 90px)', width: '100%', overflow: 'hidden' }}>
                {dashBoard}
            </div>
        )
    }
}

export default withStyles(styles)(withRouter(Projects));
